import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap"
import {BasicBitmapCountUp} from "./BasicBitmapCountUp";


/**
 * Class description
 *
 * Created: 2018-04-24
 * @author jonas
 */
export class DualLayerBitmapCountUp extends BasicBitmapCountUp {

    private readonly _topText:PIXI.BitmapText;

    constructor(topStyle:BitmapTextStyleOptions, bottomStyle:BitmapTextStyleOptions, maxWidth?:number, anchor?:PIXI.Point) {
        super(bottomStyle, maxWidth, anchor);
        this._topText = new PIXI.BitmapText("0000000", {
            fontName: topStyle.font.name!,
            fontSize: topStyle.font.size,
            align:topStyle.align,
            tint:topStyle.tint || 0xffffff
        });
        this.addChild(this._topText);
    }

    protected setAmount(value:number) {
        super.setAmount(value);
        this._topText.text = this._amountText.text;
    }

    protected updateTextLayout() {
        super.updateTextLayout();
        this._topText.position.set(this._amountText.position.x, this._amountText.position.y);
    }

    protected setScaleToFitMaxWidth(from:number, to:number):void {
        super.setScaleToFitMaxWidth(from, to);
        this._topText.scale.set(this._amountText.scale.x);
    }


    public getFadeInTopLayer(duration:number, targetAlpha:number = 1, ease:Ease = Linear.easeNone):TweenLite {
        return new TweenLite(this._topText, duration, {alpha : targetAlpha, ease : ease});
    }

    public getFadeOutTopLayer(duration:number, targetAlpha:number = 0, ease:Ease = Linear.easeNone):TweenLite {
        return new TweenLite(this._topText, duration, {alpha : targetAlpha, ease : ease});
    }

    public getFadeInAndOutTopLayer(duration:number, targetInAlpha:number = 1, targetOutAlpha:number = 0, fadeInDurationFactor:number = 0.5, ease:Ease = Linear.easeNone):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this._topText, duration * fadeInDurationFactor, {alpha : targetInAlpha, ease : ease}));
        tl.add(new TweenLite(this._topText, duration * (1 - fadeInDurationFactor), {
            alpha : targetOutAlpha,
            ease : ease
        }));

        return tl;
    }


}
